<div class="content" fxLayout="row" fxFlexFill fxLayoutAlign="space-around center">
    <form #htlBlockForm="ngForm" (ngSubmit)="onFormSubmit()" fxFlex="100" fxFlex.gt-md="70" [formGroup]="htlBlockFormGroup">
        <mat-card appearance="outlined">
            <mat-card-content>
                <div fxLayout="row" fxFlexFill fxLayoutAlign="space-around top" class="mb-15">
                    <div fxFlex fxLayout="column" fxLayoutGap="40px">
                        <div fxFlex fxLayout="row" fxLayoutGap="20px"></div>
                        <h1 fxFlex class="mat-headline-3 mb-15" style="margin: 0; font-weight: bold; text-align: center">AIRCRAFT TECHNICAL LOG</h1>
                    </div>
                    <div fxFlex="30%">
                        <mat-card appearance="outlined">
                            <mat-card-content fxLayout="column" fxFlexFill>
                                <mat-form-field fxFlex>
                                    <mat-label>ATL n.</mat-label>
                                    <input matInput name="htlNumber" formControlName="htlNumber" />
                                    @if (htlBlockFormGroup.controls["htlNumber"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field fxFlex>
                                    <mat-label>Operator</mat-label>
                                    <input matInput name="operator" formControlName="operator" />
                                    @if (htlBlockFormGroup.controls["operator"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <h3 fxFlex class="mat-h3" style="margin: 0; font-weight: bold; text-align: center">AIRCRAFT</h3>
                                <mat-form-field fxFlex>
                                    <mat-label>Type</mat-label>
                                    <input matInput name="helicopterType" formControlName="helicopterType" />
                                    @if (htlBlockFormGroup.controls["helicopterType"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field fxFlex>
                                    <mat-label>Registration</mat-label>
                                    <input matInput name="helicopterRegistrationMark" formControlName="helicopterRegistrationMark" />
                                    @if (htlBlockFormGroup.controls["helicopterRegistrationMark"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field fxFlex>
                                    <mat-label>S/N</mat-label>
                                    <input matInput name="helicopterSerialNumber" formControlName="helicopterSerialNumber" />
                                    @if (htlBlockFormGroup.controls["helicopterSerialNumber"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <div fxLayout="row" fxFlexFill fxLayoutGap="30px">
                    <div fxFlex fxLayout="column" class="pt-30">
                        <p class="mat-caption">
                            <span class="mr-5">ATL Block Number:</span>
                            <mat-form-field>
                                <input matInput name="blockSerialNumber" formControlName="blockSerialNumber" />
                                @if (htlBlockFormGroup.controls["blockSerialNumber"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <br />
                            This ATL consists of 50 pages each in 3 copies and it is approved by ENAC with reference to Prot:
                        </p>
                        <!-- <p fxFlex></p> -->
                        <mat-form-field fxFlex style="text-align: center" class="m-0">
                            <mat-label>ENAC reference Prot</mat-label>
                            <input matInput name="enacRegistrationNumber" formControlName="enacRegistrationNumber" />
                            @if (htlBlockFormGroup.controls["enacRegistrationNumber"].hasError("required")) {
                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field fxFlex class="m-0">
                            <mat-label>Issue date</mat-label>
                            <input matInput [matDatepicker]="issueDatePicker" name="issueDate" formControlName="issueDate" readonly />
                            <mat-datepicker-toggle matSuffix [for]="issueDatePicker"> </mat-datepicker-toggle>
                            <mat-datepicker #issueDatePicker></mat-datepicker>
                            @if (htlBlockFormGroup.controls["issueDate"].hasError("matDatepickerParse")) {
                                <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                            }
                            @if (htlBlockFormGroup.controls["issueDate"].hasError("required")) {
                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                            }
                        </mat-form-field>
                        <p style="font-size: 11px">Section 1A (HDS-ATL Ed. 2 Rev. 1)</p>
                    </div>
                    <div fxFlex="40%">
                        <table class="lubricants-table">
                            <thead>
                                <tr>
                                    <th>Lubricants</th>
                                    <th>Type</th>
                                    <th>Manufacturer</th>
                                </tr>
                            </thead>
                            <tbody class="mat-small">
                                <tr>
                                    <td>Engine Oil</td>
                                    <td>
                                        <mat-form-field fxFlex>
                                            <mat-select name="engineOilType" formControlName="engineOilType" (selectionChange)="onOilTypeChange($event, 'engineOilManufacturer')">
                                                @for (type of helicopterAttr?.oilTypes; track type) {
                                                    <mat-option [value]="type.name">
                                                        {{ type.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            @if (htlBlockFormGroup.controls["engineOilType"].hasError("required")) {
                                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                            }
                                        </mat-form-field>
                                    </td>
                                    <td>{{ htlBlockFormGroup.controls["engineOilManufacturer"].value }}</td>
                                </tr>
                                <tr>
                                    <td>MGB Oil</td>
                                    <td>
                                        <mat-form-field fxFlex>
                                            <mat-select name="mgboilType" formControlName="mgboilType" (selectionChange)="onOilTypeChange($event, 'mgboilManufacturer')">
                                                @for (type of helicopterAttr?.oilTypes; track type) {
                                                    <mat-option [value]="type.name">
                                                        {{ type.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            @if (htlBlockFormGroup.controls["mgboilType"].hasError("required")) {
                                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                            }
                                        </mat-form-field>
                                    </td>
                                    <td>{{ htlBlockFormGroup.controls["mgboilManufacturer"].value }}</td>
                                </tr>
                                <tr>
                                    <td>TGB Oil</td>
                                    <td>
                                        <mat-form-field fxFlex>
                                            <mat-select name="tgbOilType" formControlName="tgbOilType" (selectionChange)="onOilTypeChange($event, 'tgbOilManufacturer')">
                                                @for (type of helicopterAttr?.oilTypes; track type) {
                                                    <mat-option [value]="type.name">
                                                        {{ type.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            @if (htlBlockFormGroup.controls["tgbOilType"].hasError("required")) {
                                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                            }
                                        </mat-form-field>
                                    </td>
                                    <td>{{ htlBlockFormGroup.controls["tgbOilManufacturer"].value }}</td>
                                </tr>
                                <tr>
                                    <td>Hydraulic Fluid</td>
                                    <td>
                                        <mat-form-field fxFlex>
                                            <mat-select
                                                name="hydraulicFluidType"
                                                formControlName="hydraulicFluidType"
                                                (selectionChange)="onHydraulicFluidChange($event, 'hydraulicFluidManufacturer')"
                                            >
                                                @for (type of helicopterAttr?.hydraulicFluidTypes; track type) {
                                                    <mat-option [value]="type.name">
                                                        {{ type.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            @if (htlBlockFormGroup.controls["hydraulicFluidType"].hasError("required")) {
                                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                            }
                                        </mat-form-field>
                                    </td>
                                    <td>{{ htlBlockFormGroup.controls["hydraulicFluidManufacturer"].value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div fxFlex fxLayout="column" class="pt-30">
                        <div fxLayout="column" class="mb-40">
                            <mat-form-field fxFlex class="m-0">
                                <mat-label>Started on</mat-label>
                                <input matInput [matDatepicker]="startedOnDatePicker" name="startedOn" formControlName="startedOn" readonly />
                                <mat-datepicker-toggle matSuffix [for]="startedOnDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #startedOnDatePicker></mat-datepicker>
                                @if (htlBlockFormGroup.controls["startedOn"].hasError("matDatepickerParse")) {
                                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                                }
                                @if (htlBlockFormGroup.controls["startedOn"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex>
                                <mat-label>Airframe Total Time</mat-label>
                                <input matInput name="airframeStartedOnTotalTime" formControlName="airframeStartedOnTotalTime" />
                                @if (htlBlockFormGroup.controls["airframeStartedOnTotalTime"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div fxLayout="column">
                            <mat-form-field fxFlex class="m-0">
                                <mat-label>Up to the</mat-label>
                                <input matInput [matDatepicker]="upToDatePicker" name="upTo" formControlName="upTo" readonly />
                                <mat-datepicker-toggle matSuffix [for]="upToDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #upToDatePicker></mat-datepicker>
                                @if (htlBlockFormGroup.controls["upTo"].hasError("matDatepickerParse")) {
                                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                                }
                                @if (htlBlockFormGroup.controls["upTo"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex class="m-0">
                                <mat-label>Airframe Total Time</mat-label>
                                <input matInput name="airframeUpToTotalTime" formControlName="airframeUpToTotalTime" />
                                @if (htlBlockFormGroup.controls["airframeUpToTotalTime"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions style="text-align: right">
                <button mat-raised-button color="primary" class="btn-block" type="submit">
                    {{ "GENERAL.save" | translate }}
                </button>
            </mat-card-actions>
        </mat-card>
    </form>
</div>
